import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Itemized lists look like:`}</p>
      <ul parentName="section">
        <li parentName="ul">{`this one`}</li>
        <li parentName="ul">{`that one`}</li>
        <li parentName="ul">{`the other one`}</li>
      </ul>
      <p parentName="section">{`Note that --- not considering the asterisk --- the actual text
content starts at 4-columns in.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      